import './ProductPrice.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Price from '@/common/components/blocks/Price/Price';
import { ReactComponent as InfoIcon } from '@/ebat/assets/icons/info.svg';
import Tooltip from '@/ebat/components/blocks/Common/Tooltip/Tooltip';

import {
  ProductPriceDefaultProps,
  ProductPricePropTypes,
} from './ProductPrice.proptypes';

const ProductPrice = ({
  className,
  context,
  discountPrice,
  invoiceUnit,
  label,
  price,
  showEmptyLabel,
  sup,
  weeeAmount,
}) => {
  const { t } = useTranslation();

  const renderWeeeAmountContent = (localClassName) => {
    if (!weeeAmount) return null;

    return (
      <p className={localClassName}>
        {t('common:entities:product.price.weee_amount_long', {
          amount: (
            <Price
              className="amount"
              key={`weee-amount-${weeeAmount}`}
              sup={false}
              value={weeeAmount}
            />
          ),
        })}
      </p>
    );
  };

  return (
    <div
      className={cn(className, 'price-item')}
      data-qa-id={context || 'price-item'}
    >
      <div className="price-item__label">
        <span className="price-item__title">{label}</span>
        {weeeAmount > 0 && (
          <Tooltip
            className="price-item__info"
            context="weee-amount"
            message={renderWeeeAmountContent('price-item__tooltip')}
            position="top-right"
          >
            <InfoIcon className="price-item__info-icon" />
          </Tooltip>
        )}
      </div>
      <div className="price-item__wrapper">
        {discountPrice !== null && price && (
          <Price
            className="price-item__value--old"
            emptyLabel={t('common:entities:product.price.not_price')}
            value={price}
            sup={sup}
          />
        )}
        {discountPrice !== null && price && invoiceUnit && (
          <span className="price-item__unit">{invoiceUnit}</span>
        )}
      </div>
      <div className="price-item__wrapper">
        <Price
          className={cn({
            'price-item__value--discount': discountPrice !== null,
          })}
          emptyLabel={
            showEmptyLabel ? t('common:entities:product.price.not_price') : null
          }
          value={discountPrice ?? price}
          sup={sup}
        />
        {discountPrice === null && price && invoiceUnit ? (
          <span className="price-item__unit">{invoiceUnit}</span>
        ) : null}
      </div>
      {renderWeeeAmountContent('price-item__weee')}
    </div>
  );
};

ProductPrice.defaultProps = {
  ...ProductPriceDefaultProps,
};

ProductPrice.propTypes = {
  ...ProductPricePropTypes,
};

export default ProductPrice;
